export const CLOSE_SIDE_PANEL = 'CLOSE_SIDE_PANEL';
export const UPDATE_COUNT = 'UPDATE_ATTACHMENT_COUNT';
export const BOARD_ADD_TAG = 'BOARD_ADD_TAG';
export const BOARD_AI_PARENT_UPDATE = 'BOARD_AI_PARENT_UPDATE';
export const BOARD_SUB_TO_AI_PARENT_UPDATE = 'BOARD_SUB_TO_AI_PARENT_UPDATE';
export const BOARD_AI_DELETE = 'BOARD_AI_DELETE';
export const BOARD_AI_DESC_CHANGE = 'BOARD_AI_DESC_CHANGE';
export const BOARD_AI_END_DATE = 'BOARD_AI_END_DATE';
export const BOARD_AI_START_DATE = 'BOARD_AI_START_DATE';
export const BOARD_AI_OWNER_CHANGE = 'BOARD_AI_OWNER_CHANGE';
export const BOARD_AI_STATE = 'BOARD_AI_STATE';
export const BOARD_AI_RAG = 'BOARD_AI_RAG';
export const BOARD_AI_PRIORITY = 'BOARD_AI_PRIORITY';
export const BOARD_AI_EFFORT = 'BOARD_AI_EFFORT';
export const BOARD_REMOVE_TAG = 'BOARD_REMOVE_TAG';
export const BOARD_AI_NOTES_CHANGE = 'BOARD_AI_NOTES_CHANGE';

interface CloseSidePanel {
    type: typeof CLOSE_SIDE_PANEL,
    payload?: any
}

interface UpdateCount {
    type: typeof UPDATE_COUNT,
    aiId: string,
    countType: any,
    count: number,
    columnId: string,
    subAiData?: any
}

interface BoardAddTag {
    type: typeof BOARD_ADD_TAG,
    aiId: string,
    payload: any,
    columnId: any
}

interface BoardAiparentUpdate {
    type: typeof BOARD_AI_PARENT_UPDATE,
    id: string,
    parentId: string,
    columnId: string
}
interface BoardSubToAIparentUpdate {
    type: typeof BOARD_SUB_TO_AI_PARENT_UPDATE,
    id: string,
    oldParentId: string,
    columnId: string,
    stateVal: number
}

interface BoardAiDelete {
    type: typeof BOARD_AI_DELETE,
    aiId: string,
    columnId: string,
    parentId?: string,
    state?: string
}

interface BoardChangeAIDesc {
    type: typeof BOARD_AI_DESC_CHANGE,
    aiId: string,
    description: string,
    columnId: string
}

interface BoardAiStartDateChange {
    type: typeof BOARD_AI_START_DATE,
    aiId: string,
    startDateText: string,
    startDateTextFormatted: Date | string,
    start_date: any,
    columnId: string
}

interface BoardAiEndDateChange {
    type: typeof BOARD_AI_END_DATE,
    aiId: string,
    dueDateText: string,
    dueDateTextFormatted: Date | string,
    due_red: string,
    due_date: any,
    columnId: string
}

interface BoardAiOwnerChange {
    type: typeof BOARD_AI_OWNER_CHANGE,
    aiId: string,
    owner: string,
    first_name: string,
    last_name: string,
    ownerImg: string,
    columnId: string
}

interface BoardAiStateChange {
    type: typeof BOARD_AI_STATE,
    aiId: string,
    stateId: string,
    columnId: string
}

interface BoardAiRagChange {
    type: typeof BOARD_AI_RAG,
    aiId: string,
    ragId: string,
    columnId: string
}

interface BoardAiPriorityChange {
    type: typeof BOARD_AI_PRIORITY,
    aiId: string,
    priorityId: string,
    columnId: string
}

interface BoardAiEffortChange {
    type: typeof BOARD_AI_EFFORT,
    aiId: string,
    effortId: string,
    columnId: string
}

interface BoardRemoveTag {
    type: typeof BOARD_REMOVE_TAG,
    aiId: string,
    tagId: string,
    columnId: string
}

interface BoardChangeAINotes {
    type: typeof BOARD_AI_NOTES_CHANGE,
    aiId: string,
    notes: string,
    columnId: string
}

export type SidePanelActionTypes = CloseSidePanel 
                                 | UpdateCount
                                 | BoardAddTag
                                 | BoardAiparentUpdate
                                 | BoardSubToAIparentUpdate
                                 | BoardAiDelete
                                 | BoardChangeAIDesc
                                 | BoardAiEndDateChange
                                 | BoardAiStartDateChange
                                 | BoardAiOwnerChange
                                 | BoardAiStateChange
                                 | BoardAiRagChange
                                 | BoardAiPriorityChange
                                 | BoardAiEffortChange
                                 | BoardRemoveTag
                                 | BoardChangeAINotes;